import { UC_CUSTOMER_APPS_URL, UC_INTERNAL_TOOLING_URL } from "constants/urls"
import { usePageAssets } from "hooks/usePageAssets"
import Button from "components/ui/Button"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"
import Image from "components/ui/Image"

function UseCasesSection() {
  const { getAsset } = usePageAssets()
  const addPresetDashboardsIllustration = getAsset(
    "ed-add-preset-dashboards-svg"
  )
  const addPresetDashboardsBackground = getAsset("ed-internal-tools-cta-bg")
  const createCustomerExperiencesIllustration = getAsset(
    "ed-create-customer-experiences-svg"
  )
  const createCustomerExperiencesBackground = getAsset(
    "ed-customer-apps-cta-bg"
  )
  return (
    <Container section>
      <Heading
        label="Use Cases"
        title="Embed Analytics Anywhere"
        subtitle={
          <>
            Preset’s embedded dashboards are ideal for quickly bringing
            interactive analytics inside internal tools or fully customizing
            user experience for customer apps.
          </>
        }
        decoration="line"
      />
      <div className="mt-12 grid grid-cols-1 gap-x-14 gap-y-10 lg:grid-cols-2">
        <Item
          background={addPresetDashboardsBackground}
          image={addPresetDashboardsIllustration}
          title="Embed Preset dashboards in your internal tools."
          linkText="Internal Tools"
          linkUrl={UC_INTERNAL_TOOLING_URL}
          trackClick="Internal Tools (cta)_Embedded Dashboards"
        />
        <Item
          background={createCustomerExperiencesBackground}
          image={createCustomerExperiencesIllustration}
          title="Integrate interactive analytics in your customer-facing apps."
          linkText="Customer Apps"
          linkUrl={UC_CUSTOMER_APPS_URL}
          trackClick="Customer Apps (cta)_Embedded Dashboards"
        />
      </div>
    </Container>
  )
}

function Item({ background, image, title, linkText, linkUrl }) {
  return (
    <div className="safari-overflow-fix relative overflow-hidden rounded-2x px-6 py-8 md:px-12 md:pb-14 md:pt-16">
      <div className="absolute left-0 top-0 h-full w-full">
        <Image className="h-full w-full" src={background} />
      </div>
      <div className="relative z-10 flex flex-col gap-x-12 gap-y-3 md:flex-row">
        <Image className="w-28 flex-shrink-0 object-contain" src={image} />
        <div>
          <h4 className="text-2xl font-bold text-sage">{title}</h4>
          <Button className="mt-5" href={linkUrl} color="white" size="small">
            {linkText}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default UseCasesSection
